const Mustache = require('mustache');
import { Movax } from './Movax';

/**
 * Basic ajax search handler class
 * Handles form submit, shows result message and updates markup to the result container
 */
export class ItemSearch {
  private el:Element;
  private ajaxEndpoint: string;
  public resultTemplate: string;
  public resultContainer:Element;
  private submitButton:Element;
  private messageContainer:Element;
  private language: string;

/**
 *
 * @param selector container element selector
 * @param ajaxEndpoint ajax endpoint
 * @param resultTemplateSelector selector for script element containing mustache template
 * @param resultContainerSelector selector for container that result markup will be added
 */
  constructor(elementId:string, ajaxEndpoint: string, resultTemplateSelector: string, resultContainerSelector: string, ) {
    this.el = document.getElementById(elementId);
    this.submitButton = this.el.querySelector('.item-search__button');
    this.messageContainer = this.el.querySelector('.js-item-search-message');
    this.ajaxEndpoint = ajaxEndpoint;
    this.resultTemplate = this.el.querySelector(resultTemplateSelector).textContent;
    this.resultContainer = document.querySelector(resultContainerSelector);
    this.language = document.documentElement.lang;
  }

  /**
   * Attach listener to form submit
   */
  public attachSubmitListener() {
    this.submitButton.addEventListener('click', (event) => {
      event.preventDefault();
      const  myFormData = new FormData(this.el.querySelector('form'));
      myFormData.append('language', this.language);
      const params = {};
      myFormData.forEach((value, key) => {
        params[key] = value;
      });
      this.search(params);
    });
  }

  /**
   * Search
   * @param {object} params search parameters
   */
  public async search(params:object){
    this.submitButton.classList.add('button--loading');
    try {
      const result = await this.makeAjaxRequest(params);
      this.updateMessage(result.message, result.status);
      if(result.status === 'error') {
        this.clearResults()
      }
      this.processSearchResults(result.data);
    } catch(error) {
      this.updateMessage('Error', 'error');
      this.clearResults();
    } finally {
      this.submitButton.classList.remove('button--loading');
    }
  }

  /**
  * Process search results and add markup to the result element
  * @param {object} data - data to be rendered in the template
  */
  public processSearchResults(data:object) {
    const resultMarkup = Mustache.render(this.resultTemplate, data);
    this.resultContainer.innerHTML = resultMarkup;
  }

  /**
   * Clear results from results container
   */
  private clearResults() {
    this.resultContainer.innerHTML = '';
  }

  /**
   * Make ajax request
   * @param params
   * @returns {object} return object should contain status, message, data
   */
  private async makeAjaxRequest(params:object) {

    if(!this.ajaxEndpoint){
      throw new Error('Search failed. Endpoint undefined.');
    }

    return Movax.xhr.get(this.ajaxEndpoint, params);
  }

  private updateMessage(message:string, messageType:string) {
    if(messageType && messageType === 'error') {
      this.messageContainer.classList.add('error');
    } else {
      this.messageContainer.classList.remove('error');
    }
    this.messageContainer.innerHTML = message;
  }
}
